/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Paper, ToggleButton, ToggleButtonGroup, styled } from "@mui/material";
import iconSelect from "./assets/icon_select.svg";
import iconClose from "./assets/icon_close.svg";
import iconDelete from "./assets/icon_delete.svg";
import { FC } from "react";

const iconSize = 24;
interface Props {
  /** Current tool type */
  currentTool: ToolType;
  /** Action on current tool type changed */
  onCurrentToolChanged?: (currentTool: ToolType) => void;
}

/** Tool type */
export type ToolType = "select" | "stop" | "delete";

/**
 * Component of traffic editor tool palette
 * @param{Props} param0 Properties
 * @return{FC} Component
 */
export const ToolPalette: FC<Props> = ({
  currentTool,
  onCurrentToolChanged,
}: Props) => {
  return (
    <StyledPaper elevation={2}>
      <StyledToggleButtonGroup
        color="primary"
        value={currentTool}
        exclusive
        onChange={(e, mode) => {
          if (onCurrentToolChanged) onCurrentToolChanged(mode);
        }}
      >
        <ToggleButton value="select">
          <img
            src={iconSelect}
            width={iconSize}
            height={iconSize}
            alt="select"
          ></img>
        </ToggleButton>
        <ToggleButton value="stop">
          <img
            src={iconClose}
            width={iconSize}
            height={iconSize}
            alt="stop"
          ></img>
        </ToggleButton>
        <ToggleButton value="delete">
          <img
            src={iconDelete}
            width={iconSize}
            height={iconSize}
            alt="delete"
          ></img>
        </ToggleButton>
      </StyledToggleButtonGroup>
    </StyledPaper>
  );
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0.5, 4),
  borderRadius: "2.5em",
  pointerEvents: "all",
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    border: 0,
    "&.Mui-selected": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));
